import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'start',
      gap: theme.spacing(5),
      alignItems: 'center',
      padding: theme.spacing(4, 3, 0.75, 3),
      background: 'white',
    },
    loaderContainer: {
      height: 98,
      background: 'white',
    },

    texts: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },

    title: {
      color: COLORS.neutral.blackBlue,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      marginBottom: theme.spacing(0.5),
    },

    taxonomy: {
      textDecoration: 'underline',
    },

    changeModelButton: {
      display: 'block',
      color: COLORS.primary.default,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),

      '&:hover': {
        backgroundColor: 'unset',
      },
    },

    scoreContainer: {
      width: 48,
    },

    stonlyHintIcon: {
      fontSize: theme.typography.pxToRem(12),
      marginLeft: theme.spacing(0.5),
      marginTop: theme.spacing(3 / 8),
    },

    subtitleContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1),
      alignItems: 'center',
    },

    subtitle: {
      display: 'inline-flex',
      gap: theme.spacing(0.5),
      color: COLORS.gray.gray30,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
    },

    subtitleIcon: {
      fontSize: theme.typography.pxToRem(12),
      color: COLORS.gray.gray50,
    },

    score: {
      fontWeight: theme.typography.fontWeightSemiBold + '!important',
    },
  }),
  { name: 'ScoringMethod' }
);
